<template>
    <span :class="{
        ...displayClasses,
        ...{
            'text-secondary': isDisabled,
            'strike': isStrike,
            'font-weight-bold': isBold,
        },

    }">
        <slot/>
    </span>
</template>

<script>
    import displayClassesMixin from "./mixin/displayClassesMixin";

    export default {
        name: "TextTag",
        mixins: [displayClassesMixin],
        props: {
            // optional
            isDisabled: {
                type: Boolean,
                default: false,
            },
            isStrike: {
                type: Boolean,
                default: false,
            },
            isBlock: {
                default: false,
            },
            isBold: {
                default: false,
            },
        },
    }
</script>

<style scoped>
    .strike {
        text-decoration: line-through;
    }
</style>